import { Price } from '../../utils/price';
export function getDiscountWithAdditionalValue(items, promocodeDiscount, measurement, setupFeeDiscount, shipmentDiscount, sampleDeductionDiscount) {
  return Math.round(Price.getDiscount(items, promocodeDiscount, measurement, setupFeeDiscount)) + shipmentDiscount + sampleDeductionDiscount;
}